import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr";
import { French } from "flatpickr/dist/l10n/fr.js"

flatpickr.localize(French);

const isDateWeekend = (date) => (date.getDay() === 0 || date.getDay() === 6)

// Connects to data-controller="flatpickr"
export default class extends Controller {
  static values = {
    type: { type: String, default: 'date' },
    past: { type: Boolean, default: false },
    weekendAuthorized: { type: Boolean, default: false }
  }

  get dateOptions() {
    const minDate = this.pastValue ? null : new Date()
    const disable = this.weekendAuthorizedValue ? [] : [isDateWeekend]

    return {
      minDate: minDate,
      disable: disable,
      // appendTo: document.querySelector('dialog'),
      // static: true
    }
  }

  get timeOptions() {
    return {
      enableTime: true,
      noCalendar: true,
      dateFormat: "H:i",
      minuteIncrement: 30,
      time_24hr: true
    }
  }

  connect() {
    let options

    if (this.typeValue === 'date')
      options = this.dateOptions
    else if (this.typeValue === 'time')
      options = this.timeOptions

    flatpickr(this.element, options)
  }
}
